import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgOptimizedImage } from '@angular/common';
import { OrganizationModel } from '@cpd-app/core-module/models';

@Component({
  templateUrl: './employer-connect-dialog.component.html',
  styleUrls: ['./employer-connect-dialog.component.scss'],
  imports: [FontAwesomeModule, NgOptimizedImage],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerConnectDialogComponent {
  protected readonly employer = this.data.employerDetail;

  public constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { employerDetail: OrganizationModel },
    private readonly dialogRef: MatDialogRef<EmployerConnectDialogComponent>
  ) {}

  protected closeDialog(): void {
    this.dialogRef.close();
  }
}
